import { blob, Layout } from '@solana/buffer-layout';
import { publicKey } from '@solana/buffer-layout-utils';
import { ethAddress } from '../layout-utils';
const encoder = new TextEncoder();
const SENDER_ATTESTATION_PREFIX = 'add';
const SENDER_ATTESTATION_PREFIX_BYTES = encoder.encode(SENDER_ATTESTATION_PREFIX);
export class SenderAttestationLayout extends Layout {
    constructor(property) {
        super(55, property); // 3 ('add') + 32 (pubkey) + 20 (ethAddress)
    }
    decode(b, offset) {
        throw new Error('Method not implemented.');
    }
    encode(src, b, offset = 0) {
        offset += blob(3).encode(SENDER_ATTESTATION_PREFIX_BYTES, b, offset);
        offset += publicKey().encode(src.rewardManagerState, b, offset);
        offset += ethAddress().encode(src.senderEthAddress, b, offset);
        return offset;
    }
}
export const senderAttestationLayout = (property) => new SenderAttestationLayout(property);
//# sourceMappingURL=SenderAttestationLayout.js.map